import styled from 'styled-components';
import loadingGif from 'src/assets/gif/page-calling.gif';
import { DimmedStyled } from 'src/styles/common';

export const LoadingWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 206px;
  background-color: white;
  border-radius: 10px;
`;

export const LoadingText = styled.p`
  font-size: 16px;
  padding-top: 20px;
  font-weight: bold;
  text-align: center;
`;

export const LoadingImage = styled.div`
  width: 120px;
  height: 120px;
  background: url('${loadingGif}') no-repeat center;
  background-size: 100%;
`;

const Loading = () => {
  return (
    <DimmedStyled>
      <LoadingWrap>
        <LoadingText>
          잠시만 기다려주세요.
          <br />
          페이지를 불러오고 있습니다.
        </LoadingText>
        <LoadingImage />
      </LoadingWrap>
    </DimmedStyled>
  );
};

export default Loading;
